<template>
  <ExActionsPopUp
    :value="value"
    headline="Detach Role"
    :htmlInfo="info"
    actionLabel="Detach"
    @input="$emit('input', $event)"
    @onAction="$emit('onAction')"
    data-testid="detach-role-from-responsibility-popup"
    icon="org_icon_role"
    :applyBorderClass="true"
    :width="500"
    :centerHeadline="true"
    actionsTopSpacing="32px"
  >
  </ExActionsPopUp>
</template>

<script setup>
import { computed } from "vue";
import ExActionsPopUp from "@components/common/ExActionsPopUp.vue";

const props = defineProps({
  value: {
    type: Boolean,
    default: false,
  },
  role_name: {
    type: String,
    default: "",
  },
  responsibility_name: {
    type: String,
    default: "",
  },
});

const escapeHtml = (value) =>
  String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");

const info = computed(() => {
  const roleName = escapeHtml(props.role_name);
  const responsibilityName = escapeHtml(props.responsibility_name);

  return `<div style="margin-top: 20px;">You are about to detach Role ${roleName} from Responsibility ${responsibilityName}<br /><br /> This action will irreversibly detach all assignments of the responsibility from employees that have this role assigned.</div>`;
});
</script>
